import React from "react";
import styled from "styled-components";
import IUMRSNavBar from "./IUMRSNavbar";
import { ICAMNavroute } from '../../../utils/ICAMnavroute.js'
import IUMRSFooter from "./IUMRSFooter";
import { useDesktopSiteDetection } from "../../../hooks/mobile_desktop_mode.jsx";
import NotificationDropdown from "../../../hooks/notificationsDropdown.jsx";

const registrationData = [
    {
      timeframe: 'Early registration (March 1-July 31)',
      categories: {
        student: 200,
        academia: 400,
        industry: 450
      }
    },
    {
      timeframe: 'Regular registration (August 1-October 31)',
      categories: {
        student: 250,
        academia: 450,
        industry: 500
      }
    },
    {
        timeframe: 'Late registration (November 1-November 15)',
        categories: {
          student: 300,
          academia: 500,
          industry: 600
        }
      }
  ];
const IUMRSFeeDetail = () => {

  const isDesktopSiteOnMobile = useDesktopSiteDetection();

    return (
        <Wrapper>
        <IUMRSNavBar navroute={ICAMNavroute}/>
        <NotificationDropdown />
        <Container className={isDesktopSiteOnMobile ? 'desktop-site-mode' : ''}>
                <div className="header">
                    <h2>REGISTRATION FEE</h2>
                </div> 
                <div className="summary-section">
                    <div className="intro-text">
                        <span><i>Important notice</i></span>  
                    </div>

                    <div className="main-text">
                      <p> <span className="heading">Fee Structure</span><br/> </p>
                      <p> Registration fees, listed in USD($), will cover meeting registration, coffee/tea breaks, a light lunch on each day, an
                          opening reception, conference souvenirs, an internal city tour of Accra and copies of the
                          program and abstracts. They will also include a year of free e-membership to the MRS (including online access to
                          the MRS Bulletin). Student rates will require proof of student status; government or NGO employees will be charged
                          the academic rate.<span className="highlight"> Registration fee does not include accomodation.</span></p>

                      <p>Additionally, optional packages are open to attendees during registration at special charges. 
                        This includes a banquet on 10th December at a charge of $50 and an excursion package at a $100 charge
                        for an external tour outside the host city to the Cape Coast Castle, Kakum National Park and other attraction sites.
                        <br /> <br />Below is the fee structure for the different categories of atttendees.</p>
                    </div>
                </div> 

                <TableContainer>
                    <Table>
                        <TableHeader>
                        <tr>
                            <HeaderCell>Registration Timeframe</HeaderCell>
                            <HeaderCell>Registration Category</HeaderCell>
                            <HeaderCell style={{ textAlign: 'right' }}>Registration Fee</HeaderCell>
                        </tr>
                        </TableHeader>
                        <tbody>
                            {registrationData.map((entry, index) => (
                                <>
                                <TableRow key={index}>
                                    <TableCell rowSpan={3}>{entry.timeframe}</TableCell>
                                    <TableCell>Student</TableCell>
                                    <FeeCell>${entry.categories.student}</FeeCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Academia</TableCell>
                                    <FeeCell>${entry.categories.academia}</FeeCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Industry</TableCell>
                                    <FeeCell>${entry.categories.industry}</FeeCell>
                                </TableRow>
                                </>
                            ))}
                            </tbody>
                    </Table>
                </TableContainer>

                
            </Container>
            <IUMRSFooter />
        </Wrapper>
    )
}

const Wrapper = styled.div`
`
const Container = styled.div` 
  font-family: "Noto Serif", serif;
  font-weight: 300;

    .header{
        width: 100%;
        height: 10rem;
        background-color: #082D4A;
        margin: 0;
        text-align: center;
        
        h2{
            margin: 0;
            color: white;
            font-family: "PT Serif", serif;
            font-style: normal;
            font-weight: 600;
            letter-spacing: .005em;
            font-size: 1.5rem;
            line-height: 10rem;
            
        }
    }

    .summary-section{
        margin: 2em 2em 1em 2em;

        p{
            color:  rgb(97, 96, 96);
            line-height: 1.8em;
            font-size: 1.1em;

            .highlight{color: #a12016;}
        }

        .main-text{text-align: justify;}

        
    }
    .intro-text {
        width: 100%;
        display: flex;
        justify-content: center;
        text-align: center;
        margin-bottom: 1.5rem;

        span{
            color:  #082D4A;
            font-weight: 600;
            font-size: 1.7rem;
        }
        
        
        p {
            max-width: 90%;
            
            
        }
    }

    .heading {
        color: #082D4A;
        font-size: 1.5rem;
        font-weight: 500;
    }

    @media only screen and (min-width: 800px) {
        .header{
            h2{font-size: 2rem;}
        }
        .summary-section{
            margin: 0em 3em 1em 3em;

            .intro-text {margin-top: 3rem;}
        }
    }

    @media only screen and (min-width: 1000px) {
        .title{
            h2{
                font-size: 2.9em;
            }
        }
        .summary-section{
            width: 56em;
            margin: 0 auto;
        }
    }

    &.desktop-site-mode {
        
        .summary-section {
            margin: 3em;
            
            p {
                font-size: 0.65em;
                line-height: 1.5em;
            }
        }
        
        .intro-text span {
            font-size: 2em;
        }
        
        .heading {
            font-size: 0.9em;
        }
    }
    
`

const TableContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 5rem auto;
  font-family: Arial, sans-serif;

  @media (max-width: 600px) {
    width: 100%;
    overflow-x: auto;
  }
`;

const Table = styled.table`
  margin: 0 auto;
  width: 95%;
  border-collapse: collapse;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const TableHeader = styled.thead`
  background-color:  #082D4A;
  
`;

const HeaderCell = styled.th`
  padding: 12px;
  text-align: left;
  border: 1px solid #ddd;
  font-weight: bold;
  color: white;

  @media (max-width: 600px) {
    padding: 8px;
    font-size: 14px;
  }
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f9f9f9;
  }

  &:hover {
    background-color: #f1f1f1;
  }
`;

const TableCell = styled.td`
  padding: 12px;
  border: 1px solid #ddd;

  @media (max-width: 600px) {
    padding: 8px;
    font-size: 14px;
  }
`;

const CategoryCell = styled(TableCell)`
  display: flex;
  flex-direction: column;
`;

const FeeCell = styled(TableCell)`
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export default IUMRSFeeDetail;